import * as data from '../../../public_html/assets/data/encyclopedia/data.json';

const CONTENT = '[js-encyclopedia] p';

class Encyclopedia {
    constructor() {
      this.data = data.default;
      const pageTitle = document.documentElement.dataset.pageTitle;
      const contentFields = [...document.querySelectorAll(CONTENT)];
      
      contentFields.forEach(field => {
        if(!field.innerText) return;
        let newField = field.outerHTML;

        Object.entries(this.data).forEach(word => {
          const wordLabel = word[0];
          const wordData = word[1];
          if(wordLabel === pageTitle) return

          let regex = new RegExp("\>([^<]*?)([^A-Za-z])("+wordLabel+")([^A-Za-z])([^<]*?)\<", 'i');
          if(field.outerHTML.match(regex)) {
            delete this.data[wordLabel];
            newField = newField.replace(regex, `>$1<c-tooltip class="tooltip--encyclopedia" js-template options="click"  tip-content="<span class='tooltip__tip-body'>${wordData.body}</span>${wordData.link ? `<a href='${wordData.link}' class='tooltip__tip-info'>Meer informatie</a>` : ``}" position="bottom">${wordLabel}</c-tooltip>$5<`);
          }
        });

        field.outerHTML = newField;
      });
    }
}

export default Encyclopedia;